module.exports = __webpack_public_path__ + "static/img/08b01f0d874d978017555fc3eec79be4.product3.1709800931122.png";